export class Notification {
    assignment;
    editLink = '';
    message = '';
    user = {};
    users = [];

    constructor(notification: object) {
        this.setProperties(notification);
    }
    setProperties(args) {
        for(var i in args) {
            this[i] = args[i];
        }
    }
} 